import {ResourceFieldPermissionExpressionResponseBody} from '@dms/api/security';
import {FieldPermission} from '@dms/api/shared';

export const findUserField =
  (requestedPermission: FieldPermission) =>
  (action: ResourceFieldPermissionExpressionResponseBody) =>
    action.fieldId === requestedPermission.fieldId &&
    action.resourceId === requestedPermission.resourceId;
